import { ReactComponent as DeleteIcon } from "assets/img/DeleteBig.svg";
import { Button, ModalProps, Row } from 'antd';
import styles from './styles.module.scss';
import ModalComponent from "../ModalComponent/ModalComponent";

interface IProps extends ModalProps {
  content: React.ReactNode;
  subContent: React.ReactNode;
  modalIcon?: React.ReactNode;
  isClose?: boolean;
  isOk?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
}

export const ModalCancel = (props: IProps) => {
  const {
    onCancel,
    onOk,
    content,
    subContent,
    modalIcon,
    isClose = false,
    isOk = false,
  } = props;
  return (
    <ModalComponent
      centered
      className={styles.wrapper}
      width={414}
      {...props}
      footer={[
        <Row justify="center">
          {
            isClose && (
              <Button key="cancel" type='primary' onClick={onCancel} danger>
                Cancel
              </Button>
            )
          }
          {
            isOk && (
              <Button key="ok" type='primary' onClick={onOk}>
                Ok
              </Button>
            )
          }
        </Row>
      ]}
      content={
        <>
          <Row justify="center">
            {modalIcon ? modalIcon : <DeleteIcon />}
          </Row>
          <Row justify="center" className={styles.content}>
            <span>{content}</span>
          </Row>
          <Row justify="center" className={styles.sub}>
            {subContent}
          </Row>
        </>
      }
    />
  );
};
